export const FACING_MODE_USER = "user";
export const FACING_MODE_ENVIRONMENT = "environment";
export const FACING_MODES = [FACING_MODE_ENVIRONMENT, FACING_MODE_USER];
export type FacingMode = typeof FACING_MODE_USER | typeof FACING_MODE_ENVIRONMENT;